/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminMicrostoriesResponse,
  GetAdminMicrostoriesParams,
  HTTPValidationError,
  MicrostoryDeleteArgs,
  MicrostoryDetails,
  MicrostoryFilterOptionsResponse,
} from './platformapi.schemas';

import getAdminMicrostoriesMutator from '../custom-axios-instance';
import createMicrostoryMutator from '../custom-axios-instance';
import deleteMicrostoryMutator from '../custom-axios-instance';
import getMicrostoryFilterOptionsMutator from '../custom-axios-instance';
import getMicrostoryUpdateMutator from '../custom-axios-instance';
import updateMicrostoryMutator from '../custom-axios-instance';

/**
 * @summary Get Admin Microstories
 */
export const getAdminMicrostories = (params?: GetAdminMicrostoriesParams, signal?: AbortSignal) => {
  return getAdminMicrostoriesMutator<AdminMicrostoriesResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/microstories/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAdminMicrostoriesQueryKey = (params?: GetAdminMicrostoriesParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/microstories/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminMicrostoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMicrostories>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMicrostoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMicrostories>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminMicrostoriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMicrostories>>> = ({ signal }) =>
    getAdminMicrostories(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMicrostories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminMicrostoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminMicrostories>>
>;
export type GetAdminMicrostoriesQueryError = void | HTTPValidationError;

export function useGetAdminMicrostories<
  TData = Awaited<ReturnType<typeof getAdminMicrostories>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetAdminMicrostoriesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMicrostories>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMicrostories>>,
          TError,
          Awaited<ReturnType<typeof getAdminMicrostories>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminMicrostories<
  TData = Awaited<ReturnType<typeof getAdminMicrostories>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMicrostoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMicrostories>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMicrostories>>,
          TError,
          Awaited<ReturnType<typeof getAdminMicrostories>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminMicrostories<
  TData = Awaited<ReturnType<typeof getAdminMicrostories>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMicrostoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMicrostories>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Admin Microstories
 */

export function useGetAdminMicrostories<
  TData = Awaited<ReturnType<typeof getAdminMicrostories>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminMicrostoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminMicrostories>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminMicrostoriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Microstory
 */
export const createMicrostory = (microstoryDetails: MicrostoryDetails, signal?: AbortSignal) => {
  return createMicrostoryMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/microstories/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: microstoryDetails,
    signal,
  });
};

export const getCreateMicrostoryMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMicrostory>>,
    TError,
    { data: MicrostoryDetails },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMicrostory>>,
  TError,
  { data: MicrostoryDetails },
  TContext
> => {
  const mutationKey = ['createMicrostory'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMicrostory>>,
    { data: MicrostoryDetails }
  > = (props) => {
    const { data } = props ?? {};

    return createMicrostory(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMicrostoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMicrostory>>
>;
export type CreateMicrostoryMutationBody = MicrostoryDetails;
export type CreateMicrostoryMutationError = void | HTTPValidationError;

/**
 * @summary Create Microstory
 */
export const useCreateMicrostory = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMicrostory>>,
      TError,
      { data: MicrostoryDetails },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMicrostory>>,
  TError,
  { data: MicrostoryDetails },
  TContext
> => {
  const mutationOptions = getCreateMicrostoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Microstory
 */
export const deleteMicrostory = (
  microstoryDeleteArgs: MicrostoryDeleteArgs,
  signal?: AbortSignal,
) => {
  return deleteMicrostoryMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/microstories/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: microstoryDeleteArgs,
    signal,
  });
};

export const getDeleteMicrostoryMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMicrostory>>,
    TError,
    { data: MicrostoryDeleteArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMicrostory>>,
  TError,
  { data: MicrostoryDeleteArgs },
  TContext
> => {
  const mutationKey = ['deleteMicrostory'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMicrostory>>,
    { data: MicrostoryDeleteArgs }
  > = (props) => {
    const { data } = props ?? {};

    return deleteMicrostory(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMicrostoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMicrostory>>
>;
export type DeleteMicrostoryMutationBody = MicrostoryDeleteArgs;
export type DeleteMicrostoryMutationError = void | HTTPValidationError;

/**
 * @summary Delete Microstory
 */
export const useDeleteMicrostory = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMicrostory>>,
      TError,
      { data: MicrostoryDeleteArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMicrostory>>,
  TError,
  { data: MicrostoryDeleteArgs },
  TContext
> => {
  const mutationOptions = getDeleteMicrostoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Microstory Filter Options
 */
export const getMicrostoryFilterOptions = (signal?: AbortSignal) => {
  return getMicrostoryFilterOptionsMutator<MicrostoryFilterOptionsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/microstories/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetMicrostoryFilterOptionsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/microstories/filter-options`] as const;
};

export const getGetMicrostoryFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMicrostoryFilterOptions>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryFilterOptions>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMicrostoryFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMicrostoryFilterOptions>>> = ({
    signal,
  }) => getMicrostoryFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMicrostoryFilterOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMicrostoryFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMicrostoryFilterOptions>>
>;
export type GetMicrostoryFilterOptionsQueryError = void | HTTPValidationError;

export function useGetMicrostoryFilterOptions<
  TData = Awaited<ReturnType<typeof getMicrostoryFilterOptions>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryFilterOptions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMicrostoryFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getMicrostoryFilterOptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMicrostoryFilterOptions<
  TData = Awaited<ReturnType<typeof getMicrostoryFilterOptions>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryFilterOptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMicrostoryFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getMicrostoryFilterOptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMicrostoryFilterOptions<
  TData = Awaited<ReturnType<typeof getMicrostoryFilterOptions>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryFilterOptions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Microstory Filter Options
 */

export function useGetMicrostoryFilterOptions<
  TData = Awaited<ReturnType<typeof getMicrostoryFilterOptions>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryFilterOptions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMicrostoryFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Microstory Update
 */
export const getMicrostoryUpdate = (microstoryId: number, signal?: AbortSignal) => {
  return getMicrostoryUpdateMutator<MicrostoryDetails>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/microstories/update/${microstoryId}`,
    method: 'GET',
    signal,
  });
};

export const getGetMicrostoryUpdateQueryKey = (microstoryId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/microstories/update/${microstoryId}`] as const;
};

export const getGetMicrostoryUpdateQueryOptions = <
  TData = Awaited<ReturnType<typeof getMicrostoryUpdate>>,
  TError = void | HTTPValidationError,
>(
  microstoryId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryUpdate>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMicrostoryUpdateQueryKey(microstoryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMicrostoryUpdate>>> = ({ signal }) =>
    getMicrostoryUpdate(microstoryId, signal);

  return { queryKey, queryFn, enabled: !!microstoryId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMicrostoryUpdate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMicrostoryUpdateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMicrostoryUpdate>>
>;
export type GetMicrostoryUpdateQueryError = void | HTTPValidationError;

export function useGetMicrostoryUpdate<
  TData = Awaited<ReturnType<typeof getMicrostoryUpdate>>,
  TError = void | HTTPValidationError,
>(
  microstoryId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryUpdate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMicrostoryUpdate>>,
          TError,
          Awaited<ReturnType<typeof getMicrostoryUpdate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMicrostoryUpdate<
  TData = Awaited<ReturnType<typeof getMicrostoryUpdate>>,
  TError = void | HTTPValidationError,
>(
  microstoryId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryUpdate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMicrostoryUpdate>>,
          TError,
          Awaited<ReturnType<typeof getMicrostoryUpdate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMicrostoryUpdate<
  TData = Awaited<ReturnType<typeof getMicrostoryUpdate>>,
  TError = void | HTTPValidationError,
>(
  microstoryId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryUpdate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Microstory Update
 */

export function useGetMicrostoryUpdate<
  TData = Awaited<ReturnType<typeof getMicrostoryUpdate>>,
  TError = void | HTTPValidationError,
>(
  microstoryId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMicrostoryUpdate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMicrostoryUpdateQueryOptions(microstoryId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Microstory
 */
export const updateMicrostory = (
  microstoryId: number,
  microstoryDetails: MicrostoryDetails,
  signal?: AbortSignal,
) => {
  return updateMicrostoryMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/microstories/update/${microstoryId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: microstoryDetails,
    signal,
  });
};

export const getUpdateMicrostoryMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMicrostory>>,
    TError,
    { microstoryId: number; data: MicrostoryDetails },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMicrostory>>,
  TError,
  { microstoryId: number; data: MicrostoryDetails },
  TContext
> => {
  const mutationKey = ['updateMicrostory'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMicrostory>>,
    { microstoryId: number; data: MicrostoryDetails }
  > = (props) => {
    const { microstoryId, data } = props ?? {};

    return updateMicrostory(microstoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMicrostoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMicrostory>>
>;
export type UpdateMicrostoryMutationBody = MicrostoryDetails;
export type UpdateMicrostoryMutationError = void | HTTPValidationError;

/**
 * @summary Update Microstory
 */
export const useUpdateMicrostory = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMicrostory>>,
      TError,
      { microstoryId: number; data: MicrostoryDetails },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMicrostory>>,
  TError,
  { microstoryId: number; data: MicrostoryDetails },
  TContext
> => {
  const mutationOptions = getUpdateMicrostoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
